import type { Guide } from '../types';

/** S-20.10-11 — etap prezlecenia w banku i na karcie zlecenia (scenariusz e2e 15, ścieżka FTL-03). */
export const guide: Guide = {
  flagKey: 'preOrderStageInBank',
  title: 'Etap prezlecenia w banku i na karcie zlecenia',
  whatItDoes:
    'FTL i Trade widzą, na jakim etapie przyjęcia jest zlecenie z prezlecenia: szkic, zatwierdzone, plik dla VIA wytworzony, „Jest w TMS” — z datą wejścia w etap i działem. W banku znacznik w kolumnie „TMS” i filtr „Etap prezlecenia”, na karcie zlecenia sekcja „Etap prezlecenia” tylko do odczytu; poprawki robi przyjęcie zleceń.',
  audience: ['planista FTL', 'Trade'],
  presentationItems: ['S-20.10-11'],
  steps: [
    {
      route: '/user-offers',
      routeFilter: { forklift: 'hide', preOrderStage: 'approved' },
      target: 'pre-order-stage-chip',
      title: 'Znacznik etapu w banku',
      description:
        'W kolumnie „TMS” zlecenie z prezlecenia ma znacznik etapu z dniem. Filtr „Etap prezlecenia” pokazuje tylko zlecenia na wybranym etapie.',
      action: 'Na liście zleceń wybierz filtr „Etap prezlecenia”, np. „Zatwierdzone”.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie z prezlecenia (znacznik etapu w kolumnie „TMS”)',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', preOrderStage: 'approved' },
      },
      target: 'pre-order-stage-section',
      title: 'Sekcja „Etap prezlecenia” na karcie',
      description: 'Etap, od kiedy i dział, u którego jest prezlecenie — tylko do odczytu, bez przycisków.',
      action: 'Otwórz zlecenie ze znacznikiem etapu i sprawdź sekcję „Etap prezlecenia”.',
      recorder: { account: 'ftl', demo: { kind: 'scenario', key: 'preOrderBankRowId' } },
    },
  ],
};
